import Swal from "sweetalert2";

const swal = {
  confirm(options) {
    return new Promise((resolve) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancel",
        confirmButtonText: "Done",
      }).then((result) => {
        resolve(result);
      });
    });
  },
};

export default swal;
